import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_WEB_ADMIN, NAVIGATION_WEB_B2B, NAVIGATION_WEB_B2C } from "data/navigation";
import { useReduxReducer } from "redux/store";

function Navigation() {
  const { header } = useReduxReducer(state => state.config);
  const { isAdmin, isB2C   } = useReduxReducer(state => state.general);
  // Default navigation
  let navigation = isAdmin ? NAVIGATION_WEB_ADMIN : isB2C ? NAVIGATION_WEB_B2C : NAVIGATION_WEB_B2B;

  return (
    <ul className=" nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:space-x-1 relative">
      {navigation.map((item) => (
        <NavigationItem key={item.id} menuItem={item} />
      ))}
    </ul>
  );
}

export default Navigation;
